import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import { m as makeParamEncDec } from './encdec.es.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/typeof';
import 'memoize-one';

var qpFloat = function qpFloat() {
  return function (fromQs, toQs) {
    return fromQs && parseFloat(fromQs) || toQs && toQs.toString() || undefined;
  };
};

var qpInt = function qpInt() {
  var radix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return function (fromQs, toQs) {
    return fromQs && parseInt(fromQs, radix) || toQs && toQs.toString(radix) || undefined;
  };
};

var DefaultDateLibrary = /*#__PURE__*/function () {
  function DefaultDateLibrary(arg) {
    _classCallCheck(this, DefaultDateLibrary);

    if (arg instanceof Date) this.date = arg;else this.date = new Date(arg);
  }

  _createClass(DefaultDateLibrary, [{
    key: "format",
    value: function format() {
      return this.date.toISOString();
    }
  }, {
    key: "toDate",
    value: function toDate() {
      return this.date;
    }
  }]);

  return DefaultDateLibrary;
}();

var DefaultDateLibraryEntry = function DefaultDateLibraryEntry(arg) {
  return new DefaultDateLibrary(arg);
};

var qpDate = function qpDate() {
  var dateLibrary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultDateLibraryEntry;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm';
  return {
    encode: function encode(data) {
      return data && dateLibrary(data).format(format);
    },
    decode: function decode(data) {
      return data ? dateLibrary(data).toDate() : undefined;
    }
  };
};

var qpBool = function qpBool() {
  var trueValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1';
  var falseValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
  var repr = ["".concat(falseValue), "".concat(trueValue)];
  return {
    encode: function encode(data) {
      return data !== undefined && data !== null ? repr[!!data ? 1 : 0] : undefined;
    },
    decode: function decode(str) {
      if (str !== undefined) {
        if ("".concat(str) === repr[1]) {
          return true;
        } else if ("".concat(str) === repr[0]) {
          return false;
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    }
  };
};

var qpNullable = function qpNullable(nested_type) {
  var null_representation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'null';
  var encdec = makeParamEncDec(nested_type);
  return {
    encode: function encode(data) {
      return data === null ? null_representation : encdec.encode(data);
    },
    decode: function decode(str) {
      return str === null_representation ? null : encdec.decode(str);
    }
  };
};

var qpList = function qpList() {
  return {
    encode: function encode(a) {
      return a;
    },
    decode: function decode(a) {
      if (a === undefined || a === null) {
        return [];
      }

      return Array.isArray(a) ? a : [a];
    }
  };
};

export { qpBool, qpDate, qpFloat, qpInt, qpList, qpNullable };
